// extracted by mini-css-extract-plugin
module.exports = {"TemplateLabel":"classes_TemplateLabel__16-K7","TemplateLabelMin":"classes_TemplateLabelMin__3gPM5","CalendarInputDate":"classes_CalendarInputDate__2_K6x"};